// eslint-disable react/no-danger
import React from 'react';
import PropTypes from 'prop-types';
import * as Cookies from 'js-cookie';
import Layout from '../../../../components/Layout/Layout';
import EmployerPageLayout from '../../../../components/Employer/Layout/EmployerPageLayout/EmployerPageLayout';
import FocusArea from '../../../../components/Employer/Marketing/FocusArea/FocusArea';
import ResourceTitle from '../../../../components/Employer/Marketing/ResourceTitle/ResourceTitle';
import ResourceTag from '../../../../components/Employer/Marketing/ResourceTag/ResourceTag';
import Article from '../../../../components/Employer/Marketing/Article/Article';
import ResourceRegistration from '../../../../components/Employer/Marketing/ResourceRegistration/ResourceRegistration';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import { stripAdPlaceholderText } from '../../../../utilities/helperFunctions';
import { PAGE_DISPLAY_MODE } from '../../../constants';

import './SingleResource.scss';

const constructInnerHtml = (html) => ({ __html: html });

export class SingleResource extends React.PureComponent {
    componentDidMount() {
        if (this.props.redirectUrl) {
            Cookies.set('EMPLOYER_REDIRECT_URL', this.props.redirectUrl);
        }
    }

    getContentBodyOrAmpScript = () => {
        const { googleAMP, contentBody } = this.props;

        // if googleAMP !== null then we should return a div with the amp script injected
        if (googleAMP) {
            const script = `<script type='application/ld+json'>${googleAMP}</script>`;
            return (
                <div
                    className="resource-text"
                    dangerouslySetInnerHTML={constructInnerHtml(script)}
                />
            );
        }

        // otherwise we have to render normal div with content html injected + ad text stripped
        return (
            <div
                className="resource-text"
                dangerouslySetInnerHTML={constructInnerHtml(
                    stripAdPlaceholderText(contentBody)
                )}
            />
        );
    };

    render() {
        const {
            type,
            title,
            headerImage,
            marketingTag,
            author,
            marketoFormId,
        } = this.props;

        const isArticle = type === 'editorial_content';

        const contentElement = this.getContentBodyOrAmpScript();

        return (
            <React.Fragment>
                <FocusArea src={headerImage.src} alt={headerImage.alt} />
                <div className="content-container">
                    <ResourceTag
                        text={marketingTag.name}
                        href={marketingTag.url}
                    />
                    <ResourceTitle text={title} />
                    {isArticle ? (
                        <Article
                            author={author}
                            contentElement={contentElement}
                        />
                    ) : (
                        <ResourceRegistration
                            contentElement={contentElement}
                            formId={marketoFormId}
                        />
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default (props) => {
    const { pageDisplayMode } = props.PAGE_PROPS;

    if (pageDisplayMode === PAGE_DISPLAY_MODE.EMPLOYER_DEFAULT) {
        return (
            <div className="page-Employer-Marketing-SingleResource">
                <SnowplowPageViewTracker
                    pageEntityId={props.url}
                    pageSection={PAGE_VIEW_SECTIONS.EMPLOYER_RESOURCES}
                    pageType={PAGE_VIEW_TYPES.CONTENT}
                />
                <Layout
                    PAGE_PROPS={props.PAGE_PROPS}
                    className="employer-view-single-resource-layout"
                >
                    <SingleResource {...props} />
                </Layout>
            </div>
        );
    }

    return (
        <div className="page-Employer-Marketing-SingleResource">
            <SnowplowPageViewTracker
                pageEntityId={props.url}
                pageSection={PAGE_VIEW_SECTIONS.EMPLOYER_RESOURCES}
                pageType={PAGE_VIEW_TYPES.CONTENT}
            />
            <EmployerPageLayout PAGE_PROPS={props.PAGE_PROPS}>
                <SingleResource {...props} />
            </EmployerPageLayout>
        </div>
    );
};

SingleResource.propTypes = {
    type: PropTypes.oneOf(['editorial_content', 'download', 'event'])
        .isRequired,
    headerImage: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
    }).isRequired,
    title: PropTypes.string.isRequired,
    marketingTag: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    }).isRequired,
    contentBody: PropTypes.string.isRequired,
    author: PropTypes.shape({
        // null if type !== editorial_content
        username: PropTypes.string.isRequired,
        image: PropTypes.shape({
            src: PropTypes.string.isRequired,
            alt: PropTypes.string.isRequired,
        }).isRequired,
    }),
    url: PropTypes.string.isRequired,
    marketoFormId: PropTypes.number, // null if type === editorial_content
    googleAMP: PropTypes.string, // null if type !== editorial_content
    redirectUrl: PropTypes.string,
};

SingleResource.defaultProps = {
    author: null,
    marketoFormId: null,
    googleAMP: null,
    redirectUrl: null,
};
